import { useLocation, useParams } from "react-router-dom";

const introspectionMap = [
  {
    range: [1, 8],
    programId: 1,
    title: "RAR - Rani razvoj - utjecaj na život",
  },
  { range: [9, 14], programId: 3, title: "OR1 - Osobni razvoj 1. godina" },
  { range: [15, 20], programId: 4, title: "OR2 - Osobni razvoj 2. godina" },
  { range: [21, 26], programId: 5, title: "OR3 - Osobni razvoj 3. godina" },
  { range: [27, 32], programId: 6, title: "OR4 - Osobni razvoj 4. godina" },
  {
    range: [33, 40],
    programId: 2,
    title: "eRAR - Rani razvoj - utjecaj na život",
  },
  { range: [41, 46], programId: 7, title: "eOR1 - Osobni razvoj 1. godina" },
  { range: [47, 52], programId: 8, title: "eOR2 - Osobni razvoj 2. godina" },
  { range: [53, 58], programId: 9, title: "eOR3 - Osobni razvoj 3. godina" },
  { range: [59, 64], programId: 10, title: "eOR4 - Osobni razvoj 4. godina" },
];

export function useIntrospectionData(
  isMentorRole,
  groupProgramId,
  introspectionIdMentor
) {
  const { index } = useParams();
  const location = useLocation();

  const introspectionId = isMentorRole
    ? introspectionIdMentor
    : parseInt(index ?? "0", 10);

  let programId = isMentorRole
    ? groupProgramId
    : (location?.state?.programId ?? null);

  let title = location?.state?.title ?? "";

  const matched = introspectionMap.find(
    ({ range }) => introspectionId >= range[0] && introspectionId <= range[1]
  );

  if (matched) {
    programId = matched.programId;
    title = matched.title;
  }

  return { introspectionId, programId, title };
}
